import { Pipe, PipeTransform } from '@angular/core';
import { PermissionKey } from '../authentication/models/permission.types';
import { PermissionService } from '../services/permission.service';

@Pipe({ name: 'can', standalone: true, pure: false })
export class CanPipe implements PipeTransform {
  public constructor(private readonly permissionService: PermissionService) {}

  public transform(key: PermissionKey): boolean {
    return this.permissionService.has(key);
  }
}

@Pipe({ name: 'canAny', standalone: true, pure: false })
export class CanAnyPipe implements PipeTransform {
  public constructor(private readonly permissionService: PermissionService) {}

  public transform(keys: PermissionKey[]): boolean {
    return this.permissionService.any(keys);
  }
}

@Pipe({ name: 'canAll', standalone: true, pure: false })
export class CanAllPipe implements PipeTransform {
  public constructor(private readonly permissionService: PermissionService) {}

  public transform(keys: PermissionKey[]): boolean {
    return this.permissionService.all(keys);
  }
}
